import { updatesData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function UpdatesSection() {
  const ref = useScrollReveal();
  return (
    <section id="updates" ref={ref} className="reveal-section py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            平台更新快讯，第一时间了解最新资源与功能动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, idx) => (
            <div key={idx} className="relative flex gap-6 pb-8 last:pb-0">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 rounded-full bg-accent-500 flex-shrink-0 mt-1.5"></div>
                {idx < updatesData.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-2"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-xs font-medium text-accent-600">{item.date}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-1 mb-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}